<template>
  <svg width="0" height="0" aria-hidden="true" focusable="false" class="ws-gradient-defs">
    <defs>
      <linearGradient id="ws-grad-brand" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stop-color="#8e2de2" />
        <stop offset="100%" stop-color="#ff007f" />
      </linearGradient>
      <linearGradient id="ws-grad-serie" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stop-color="#ff6b9d" />
        <stop offset="100%" stop-color="#6e11b0" />
      </linearGradient>
      <linearGradient id="ws-grad-pelicula" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stop-color="#f6339a" />
        <stop offset="100%" stop-color="#861043" />
      </linearGradient>
      <linearGradient id="ws-grad-espectaculo" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stop-color="#2b7fff" />
        <stop offset="100%" stop-color="#0d47a1" />
      </linearGradient>
      <linearGradient id="ws-grad-articulo" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stop-color="#10b981" />
        <stop offset="100%" stop-color="#047857" />
      </linearGradient>
    </defs>
  </svg>
</template>

<script setup>
/**
 * Degradados SVG con nombre, disponibles para toda la app.
 *
 * Se monta UNA vez en el layout. Cualquier icono puede pintarse con ellos vía
 * `fill: url(#ws-grad-pelicula)`.
 *
 * Ojo: los `<defs>` son globales al documento, pero solo si están montados.
 * Cada página de listado llevaba su propio <svg><defs> con un id distinto
 * (movie-gradient, tvshow-gradient, show-gradient); al compartir la cabecera
 * hay que usar estos, o el icono se queda invisible sin dar ningún error
 * (`color: transparent` + un fill que no resuelve).
 */
</script>

<style scoped>
.ws-gradient-defs {
  position: absolute;
  width: 0;
  height: 0;
  overflow: hidden;
}
</style>
